export enum PoolTypes {
    BTC,
    ETH,
    USD,
    OTHER,
  }